import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import { Dropdown, Tooltip } from 'antd';
import React, { FC, ReactNode, useState } from 'react';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { useTranslation } from 'hooks/use-translation';
import { DeleteConfirmationPopup } from './delete-confirm-popup';

interface Props {
  data: any;
  disabledAction: boolean;
  showModalAlert?: boolean;
  titleNode?: ReactNode | string;
  contentNode?: ReactNode | string;
  attachTo?: HTMLElement;
  onDelete?: (record: any) => void;
}

const DELETE_KEY = 'delete';

export const MoreActions: FC<Props> = ({
  data,
  onDelete,
  disabledAction,
  showModalAlert,
  attachTo,
  titleNode,
  contentNode,
}) => {
  const [isMoreActionsMenuOpen, setIsMoreActionsMenuOpen] = useState(false);

  const [isDeleteConfirmationVisible, setIsDeleteConfirmationVisible] =
    useState(false);

  const handleDeleteConfirmationVisible = (isVisible: boolean) => {
    setIsDeleteConfirmationVisible(isVisible);
  };

  const handleMoreActionsMenuVisibleChange = (isVisible) => {
    setIsDeleteConfirmationVisible(false);
    setIsMoreActionsMenuOpen(isVisible);
  };

  const handleDeleteClick = () => {
    setIsMoreActionsMenuOpen(true);
  };

  const closeDropdown = () => {
    setIsDeleteConfirmationVisible(false);
    setIsMoreActionsMenuOpen(false);
  };

  const handleConfirmDelete = () => {
    if (onDelete) {
      onDelete(data);
    }
    closeDropdown();
  };

  const menu = () => (
    <Menu>
      <Menu.ItemDelete
        onClick={handleDeleteClick}
        key={DELETE_KEY}
        data-cy="more_actions.delete"
      >
        <DeleteConfirmationPopup
          titleNode={titleNode}
          contentNode={contentNode}
          showModalAlert={showModalAlert}
          handleMoreActionsMenuVisibleChange={
            handleMoreActionsMenuVisibleChange
          }
          handleConfirmDelete={handleConfirmDelete}
          handleDeleteConfirmationVisible={handleDeleteConfirmationVisible}
          isDeleteConfirmationVisible={isDeleteConfirmationVisible}
        />
      </Menu.ItemDelete>
    </Menu>
  );
  const moreActions = useTranslation('more_actions');

  return (
    <Tooltip title={moreActions}>
      <Dropdown
        getPopupContainer={attachTo ? () => attachTo : undefined}
        disabled={disabledAction}
        visible={isMoreActionsMenuOpen}
        onVisibleChange={handleMoreActionsMenuVisibleChange}
        overlay={menu}
        trigger={['click']}
        placement="bottomRight"
      >
        <Button
          disabled={disabledAction}
          type="text"
          icon={<OverflowMenuVertical16 />}
          size="small"
          data-cy="more_actions.trigger"
        />
      </Dropdown>
    </Tooltip>
  );
};
